<template>
  <router-view></router-view>
</template>

<script>

export default {

  data () {
    return {
      value1: 5,
      value2: 3
    }
  }
}
</script>

<style>

</style>
